import React, { useEffect } from "react";
import "./QualityPolicy.css";
import {
  FaUserTie,
  FaUsers,
  FaCheckDouble,
  FaLightbulb,
  FaGem,
  FaCogs,
  FaBullseye,
  FaMicrochip,
  FaShippingFast,
} from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";

export default function QualityPolicy() {
  const policyPoints = [
    {
      id: 1,
      title: "Customer Focus",
      text: "The satisfaction of customers shall be the primary focus of quality management activities.",
      icon: <FaUserTie />,
    },
    {
      id: 2,
      title: "Employee Integration",
      text: "Employees are integral to the quality process and management shall work closely with them to meet customer's needs.",
      icon: <FaUsers />,
    },
    {
      id: 3,
      title: "Teamwork",
      text: "Staff shall be encouraged to participate in quality improvement activities through teamwork.",
      icon: <FaCheckDouble />,
    },
    {
      id: 4,
      title: "Individual Responsibility",
      text: "All staff shall have individual responsibility for understanding and applying this quality policy in the performance of their tasks.",
      icon: <FaLightbulb />,
    },
    {
      id: 5,
      title: "Management Commitment",
      text: "Company management is fully committed to their Quality Policy through active participation in quality improvement activities.",
      icon: <FaGem />,
    },
  ];

const coreValues = [
  { name: "Leadership", icon: "👑" },
  { name: "Excellence", icon: "⭐" },
  { name: "Proficiency", icon: "⚙️" },
  { name: "Commitment", icon: "🤝" }
];;

  const managementPillars = [
    {
      title: "Methodical Approach",
      desc: "Our design process goes through a methodical approach to ensure details are covered as agreed with our customers",
      icon: <FaCogs />,
    },
    {
      title: "Precision in Design",
      desc: "Exactness in design is what we try to achieve through series of coordination with all stakeholders.",
      icon: <FaBullseye />,
    },
    {
      title: "Technical Expertise",
      desc: "Developing technical expertise in every field we involve is our key objective.",
      icon: <FaMicrochip />,
    },
    {
      title: "Timely Delivery",
      desc: "Keeping up with the delivery expectations of our customers is our most valuable intent.",
      icon: <FaShippingFast />,
    },
  ];

  useEffect(() => {
  AOS.init({ duration: 1000 });
}, []);

  return (
        <>
      <Navbar />
    <section className="quality-policy-section">
      <div className="container">
        {/* Slide 1: Quality Policy */}
        <div className="policy-header" data-aos="fade-up">
          <h2 className="section-title">Quality Policy</h2>
          <div className="title-underline"></div>
        </div>

        <div className="policy-grid">
          {policyPoints.map((point) => (
            <div className="policy-card" key={point.id} data-aos="zoom-in">
              <div className="policy-icon">{point.icon}</div>
              <h3>{point.title}</h3>
              <p>{point.text}</p>
            </div>
          ))}
        </div>

        {/* Core Values Section */}
        <div className="core-values-wrapper" data-aos="fade-up">
          <h4 className="sub-heading">Core Values</h4>
          <div className="values-flex">
          {coreValues.map((value, index) => (
  <span key={index} className="value-tag">
    {value.icon} {value.name}
  </span>
))}
          </div>
        </div>

        {/* Slide 2: Quality Management */}
        <div className="management-container" data-aos="fade-up">
          <h2 className="section-title">Quality Management</h2>
          <div className="title-underline"></div>
          <p className="management-intro">
            Infosight’s Quality Management system is founded based on the premise that quality measures will result in less reworks, higher productivity, lower cost and increased stakeholder satisfactions while meeting our 
agreed expectations with our customers.

          </p>
          <p className="management-intro1">We believe in achieving our quality objectives through</p>

          <div className="management-grid">
            {managementPillars.map((pillar, index) => (
              <div className="mgmt-card" key={index} data-aos="fade-right" data-aos-delay={index * 100}>
                <div className="mgmt-icon">{pillar.icon}</div>
                <div className="mgmt-text">
                  <h5>{pillar.title}</h5>
                  <p>{pillar.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="purpose-statement" data-aos="flip-up">
            <span>Purpose Statement of Quality:</span>
            <p>“Translating technology into a seamless experience.” </p>
          </div>
        </div>
      </div>
    </section>
    <Footer/>
    </>
  );
}